import React from "react";

type CornerResizeIconProps = {
  className?: string;
};

const CORNER_PATH = 'M11.5 3.5V11.5H3.5';

export function CornerResizeIcon({ className }: CornerResizeIconProps) {
  return (
    <svg
      className={className ?? "email-builder-image-resize-corner-icon"}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      aria-hidden>
      <path
        d={CORNER_PATH}
        fill="none"
        stroke="#fff"
        strokeWidth="3.5"
        strokeLinecap="square"
      />
      <path
        d={CORNER_PATH}
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </svg>
  );
}
